<template>

    <!--
    ************************************************
    Area de proceso de pago e informacion de reserva
    ************************************************
    -->
    <v-container fluid>
      <v-row>
        <v-col class="col-sm-8"> <!-- media fila izq. stepper del proceso de reserva -->

            <form style="background-color: inherit">
                <div class="form-group entradaDatosUnico">
                    <label for="nombrefac">{{ $t('datosReservaNombreFac') }}</label>
                    <input type="text" v-model="datosReserva.nombreFac" id="nombrefac" name="nombrefac" class="form-control"
                           :class="{ 'is-invalid': submitted && $v.datosReserva.nombreFac.$error }" />
                    <div v-if="submitted && !$v.datosReserva.nombreFac.required" class="invalid-feedback">
                    {{ $t('errorNoNombreFac') }}
                    </div>
                </div>
                <div class="form-group entradaDatosUnico">
                    <label for="cif">{{ $t('datosReservaCif') }}</label>
                    <input type="text" v-model="datosReserva.cif" id="cif" name="cif" class="form-control"
                           :class="{ 'is-invalid': submitted && $v.datosReserva.cif.$error }" />
                    <div v-if="submitted && !$v.datosReserva.cif.required" class="invalid-feedback">
                    {{ $t('errorNoCIF') }}
                    </div>
                </div>
                <div class="form-group entradaDatosUnico">
                    <label for="direccion">{{ $t('datosReservaDireccion') }}</label>
                    <input type="text" v-model="datosReserva.direccion" id="direccion" name="direccion" class="form-control"
                           :class="{ 'is-invalid': submitted && $v.datosReserva.direccion.$error }" />
                    <div v-if="submitted && !$v.datosReserva.direccion.required" class="invalid-feedback">
                    {{ $t('errorNoDireccion') }}
                    </div>
                </div>
                <div class="form-group entradaDatosUnico">
                    <label for="localidad">{{ $t('datosReservaLocalidad') }}</label>
                    <input type="text" v-model="datosReserva.localidad" id="localidad" name="localidad" class="form-control"
                           :class="{ 'is-invalid': submitted && $v.datosReserva.localidad.$error }" />
                    <div v-if="submitted && !$v.datosReserva.localidad.required" class="invalid-feedback">
                    {{ $t('errorNoLocalidad') }}
                    </div>
                </div>
                <div class="form-group entradaDatosUnico">
                    <label for="cp">{{ $t('datosReservaCp') }}</label>
                    <input type="text" v-model="datosReserva.cp" id="cp" name="cp" class="form-control"
                           :class="{ 'is-invalid': submitted && $v.datosReserva.cp.$error }" />
                    <div v-if="submitted && !$v.datosReserva.cp.required" class="invalid-feedback">
                    {{ $t('errorNoCP') }}
                    </div>
                </div>


            </form>

                  <v-overlay v-model="dialog">
                    <v-progress-circular
                      size="120"
                      width="12"
                      color="red"
                      indeterminate
                      justify="center"
                      align="center">
                    </v-progress-circular>
                  </v-overlay>

                  <v-alert class="entradaDatosUnico" style="margin-bottom:10px;"
                        :value="alerta.mostrar"
                        :color="alerta.color"
                        dark
                        border="top"
                        icon="mdi-home"
                        transition="scale-transition">
                    {{ this.alerta.texto }}
                  </v-alert> <!-- para mostrar mensaje de error de comunicacion -->

                  <div class="entradaDatosUnico" style="margin-top:20px;">
                    <v-btn
                      class="mx-auto "
                      outlined
                      color="#4894ef"
                      @click="comprobarDatosUsuario()">
                      {{ $t('btnSolicitarFactura') }}
                    </v-btn>
                  </div>



        </v-col> <!-- fin media fila izq. stepper -->


        <v-col class="col-sm-4"> <!-- media fila der. informacion de la reserva solicitada-->

          <div class="">

            <!-- solo se pinta cuando se leen los datos almacenados en local storage -->
            <template v-if="cargado == true">

                <v-col class="columna">
                  <v-row cols="auto" class="mr-auto ml-auto tituloInfoReserva" align="center" justify="center">
                    {{ $t('resumenTitulo') }}
                  </v-row>

                  <div class="infoReserva">

                    <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start">
                      <label class="nombreParking">{{ $t('inicioNombreParking') }}</label>
                    </v-row>

                    <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start">
                      <label class="txtInfoReserva">{{ $t('datosReservaFechaEntrada') }}</label>
                      <label class="datoInfoReserva">{{ fecha(datosReserva.fechaEntrada) }}</label>
                    </v-row>

                    <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start">
                      <label class="txtInfoReserva">{{ $t('datosReservaFechaSalida') }}</label>
                      <label class="datoInfoReserva">{{ fecha(datosReserva.fechaSalida) }}</label>
                    </v-row>

                    <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start">
                      <label class="txtInfoReserva">{{ $t('datosReservaMatricula') }}</label>
                      <label class="datoInfoReserva">{{ datosReserva.matricula }}</label>
                    </v-row>

                    <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start">
                      <label class="txtInfoReserva">{{ $t('datosReservaTelefono') }}</label>
                      <label class="datoInfoReserva">{{ datosReserva.telefono }}</label>
                    </v-row>

                    <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start">
                      <label class="txtInfoReserva">{{ $t('datosReservaModelo') }}</label>
                      <label class="datoInfoReserva">{{ datosReserva.modelo }}</label>
                    </v-row>

                    <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start">

                      <label class="txtPrecio2">{{ $t('resumenSubTotal') }}</label>
                      <v-spacer></v-spacer>
                      <label class="subTotal">{{ datosReserva.importeReserva }}</label>

                    </v-row>

                    <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start">
                      <label class="txtPrecio2">{{ $t('resumenTotal') }}</label>
                      <v-spacer></v-spacer>
                      <label class="total">{{ calcularTotal() }}</label>
                    </v-row>
                  </div>

                  <v-row cols="auto" class="mr-auto ml-auto pieInfoReserva" align="center" justify="center">
                    <font-awesome-icon class="iconoPieInfo" :icon="['fas', 'calendar-check']"/>
                    {{ $t('resumenPieGarantia') }}
                  </v-row>

                  <v-row cols="auto" class="mr-auto ml-auto politicas" align="center" justify="start">
                    <router-link
                      :to="{ name: 'aviso_legal', params: {tipoPagina: 0 } }"
                      style="margin-left: 5px;" class="mr-2_">
                      <span style="white-space:nowrap;">{{ $t('avisolegal') }}</span>
                    </router-link>
                    ,
                    <router-link
                      :to="{ name: 'aviso_legal', params: {tipoPagina: 1 } }"
                      style="margin-left: 5px; margin-right: 5px;" class="mx-2_">
                      <span style="white-space:nowrap;">{{ $t('politicaDevolucion') }}</span>
                    </router-link>
                    {{ $t('y') }}
                    <router-link
                      :to="{ name: 'aviso_legal', params: {tipoPagina: 2 } }"
                      style="margin-left: 5px;" class="mx-2_">
                      <span style="white-space:nowrap;">{{ $t('politicaprivacidad') }}</span>
                    </router-link>

                  </v-row>

                  <v-row cols="auto" class="mr-auto ml-auto avisoCorreo text-justify" align="center" justify="start">
                    {{ $t('resumenAvisoCorreoFactura') }}
                  </v-row>

                </v-col>

            </template>
            <template v-else>
              <p>Cargando!!!</p>
            </template>

          </div> <!-- fin titulo Completa tu reserva -->









        </v-col>  <!-- fin media fila der. informacion -->

      </v-row>
    </v-container>





</template>


<style scoped>

  .tituloInfoReserva {
    padding: 10px;
    background-color: white;
    color: #4894ef;
    border-bottom: 1px solid rgb(240, 220, 220);
  }

  .pieInfoReserva {
    padding: 10px;
    background-color: #4894ef;
    color: white;
  }

  .infoReserva {
    background-color: white;
    color: black;
  }

  .nombreParking {
    margin-top: 10px;
    margin-left: 10px;
    margin-bottom: 10px;

    font-size: 16px;
  }

  .titReservaConfirmada {
    margin-top: 10px;
    margin-left: 10px;
    margin-bottom: 10px;

    font-size: 20px;
    font-weight: bold;
  }

  .txtInfoReserva {
    margin-left: 10px;
    font-size: 14px;
    font-weight: bold;
  }

  .datoInfoReserva {
    margin-left: 10px;
    font-size: 14px;
    font-weight: normal;
  }

  .txtPrecio {
    margin-left: 10px;
    margin-top: 20px;
    font-size: 16px;
    font-weight: bold;
  }

  .txtPrecio2 {
    margin-left: 10px;
    margin-top: 0px;
    font-size: 16px;
    font-weight: bold;
  }


  .subTotal{
    margin-left: 10px;
    margin-right: 10px;
    font-size: 10px;
  }

  .total{
    margin-left: 10px;
    margin-right: 10px;
    font-size: 40px;
    color:#4894ef;
    font-weight: bold
  }

  .iconoPieInfo{
    font-size:25px;
    color:white;
    margin-right: 10px;
  }

  .politicas{
    margin-top: 20px;
    font-size: 12px;
    font-weight: normal;
    color: #4894ef;
  }

  .avisoCorreo{
    margin-top: 20px;
    font-size: 12px;
    font-weight: bold;
    color: black;
  }

  .contacto{
    margin-top: 20px;
    font-size: 12px;
    font-weight: normal;
    color: black;
  }


 .entradaDatosUnico {
    margin-left: 0px;
    margin-right: 0px;
  }

 .desplegableDatosFacturacion {
    margin-left: 2%;
    margin-right: 2%;
  }


</style>




<script>
// comunicacion HTTP con RestApi
import api from "@/plugins/api.js";

// constantes para todo el proyecto
import { escribirLog } from '@/plugins/utilidades.js'


// validacion de formularios
import { required /*, email /*, minLength, sameAs*/ } from "vuelidate/lib/validators";


export default {
  name: "PaginaObtenerFactura",

  data: () => ({
    //indica si se ha pulsado el boton de aceptar formulario
    submitted: false,

    // indicador de que se ha recuperado los datos de reserva de localStorage
    cargado: false,

    // indicador de avance stepper procesoPago
    procesoPago: 1,

    reservaSinPagar: false,

    dialog: false,

    // cuenta el numero de veces que se produce el evento load del iframe
    cuentaEventoLoad: 0,

    // url de pago en PayComet
    urlPago: '',

    codigoDescuento: {
      codigo: '',
      importe: 0
    }, // fin objeto codigoDescuento

    alerta: {
      mostrar: false,
      texto: '',
      color: 'pink'
    }, //fin objeto alerta

    datosReserva: {
      importeReservaNumero: 0,
      importeReserva: "",
      horaEntrada: "00:00",
      fechaEntrada: null,
      horaSalida: "00:00",
      fechaSalida: null,
      matricula: "",
      modelo: "",
      color: "",
      crucero: "",
      idClienteBD: 0,
      nombre: "",
      mail: "",
      telefono: "",
      nombreFac: "",
      cif: "",
      direccion: "",
      localidad: "",
      cp: "",
      pais: "",
      aceptacionTerminos: "",
      idReservaBD: -1,
      merchant_order: ""
    }, // fin objeto data.datosReserva

    datosReservaParking: {
      locator: "",
      barcode: "",
      barcode_type: "",
      description: "",
      door_pinpad_key: "",
      id: "",
      media_type: 0,
      number: "",
      imagenQR: ""
    }, // fin objeto data.datosReservaParking

    datosReservaSinPagar: {
      locator: "",
      codinsclo: 0,
      idReservaBD: -1
    }, // fin objeto data.datosReservaParking

  }),

  validations: {
          datosReserva: {
                cif: { required },
                direccion: { required },
                nombreFac: { required },
                cp: { required },
                localidad: { required },
            }
// un campo a validar
  },  // validacion de formularios con vuelidation

  methods: {
    fecha: function(aFecha){
      // devuelve formateadas y traducidad las fechas de entrada y salida

      var txtFecha = '';
      var ffecha = this.$moment(aFecha);

      if ('en' == this.$i18n.locale){
        txtFecha = ffecha.locale(this.$i18n.locale).format("dddd, MMMM Do YYYY, HH:mm");
      } else {
        txtFecha = ffecha.locale(this.$i18n.locale).format("dddd, DD MMMM YYYY, HH:mm");
      }

      return txtFecha;

    }, // fin metodo fecha

    calcularTotal: function(){
      // el total a pagar es el importe menos el descuento
      var elTotal = this.datosReserva.importeReserva - this.codigoDescuento.importe;
      return elTotal + '€';
    }, //fin metodo calcularTotal

    solicitarFacturaPorMail: function(){
    // ordena al backend la generación y envío de factura por email
        this.alerta.mostrar = false;
        this.alerta.texto = '';

        const datosPeticion = {
                "id_reserva": this.datosReserva.idReservaBD,
                "nombre": this.datosReserva.nombre,
                "telefono": this.datosReserva.telefono,
                "nombreFac": this.datosReserva.nombreFac,
                "cif": this.datosReserva.cif,
                "direccion": this.datosReserva.direccion,
                "localidad": this.datosReserva.localidad,
                "cp": this.datosReserva.cp,
                "idioma": window.localStorage.getItem("idioma")
        };


      // orden al backend de almacenamiento de datos de reserva en BD
      api.generarFactura(datosPeticion)
        .then(response => {
          if ((200 == response.status) && (response.data.resultado == 'OK')){
            this.alerta.color = "green";
            this.alerta.mostrar = true;
            this.alerta.texto = this.$t('reviseSuCorreo');

          } else {
            this.alerta.mostrar = true;
            this.alerta.texto = response.data.error_message;
          }

        })
        .catch(error => {
          escribirLog('Error solicitarFacturaPorMail')
          //escribirLog(error);

          this.alerta.mostrar = true;
          this.alerta.texto = error;
        })
        .finally(() => {
          escribirLog('Final solicitarFacturaPorMail');

        })
    }, // fin metodo solicitarFacturaPorMail


    comprobarDatosUsuario: function (){
        /* comprobacion de que los datos del formulario son correctos
           antes de continuar con el proceso de reserva */

        this.submitted = true;

        escribirLog(this.datosReserva);

        // stop here if form is invalid
        this.$v.$touch();
        if (this.$v.$invalid) {
            escribirLog('invalido');
            return;
        }

        this.solicitarFacturaPorMail();
    }, // fin metodo comprobarDatosUsuario

  }, // fin methods




  mounted: function() {
    // recuperamos los datos de la reserva almacenados en local por la pantalla anterior

    this.datosReserva.idReservaBD = window.localStorage.getItem("idReservaBD");
    this.datosReserva.importeReserva = window.localStorage.getItem("importeReserva");
    this.datosReserva.importeReservaNumero = window.localStorage.getItem("importeReservaNumero");
    // las fechas de entrada/salida incluyen la informacion de la hora
    this.datosReserva.fechaEntrada = window.localStorage.getItem("fechaEntrada");
    this.datosReserva.fechaSalida = window.localStorage.getItem("fechaSalida");
    this.datosReserva.matricula = window.localStorage.getItem("matricula");
    this.datosReserva.modelo = window.localStorage.getItem("modelo");
    this.datosReserva.color = window.localStorage.getItem("color");
    this.datosReserva.crucero = window.localStorage.getItem("crucero");
    this.datosReserva.nombre = window.localStorage.getItem("nombre");
    this.datosReserva.mail = window.localStorage.getItem("mail");
    this.datosReserva.telefono = window.localStorage.getItem("telefono");

    this.datosReserva.direccion = window.localStorage.getItem("direccion");
    this.datosReserva.localidad = window.localStorage.getItem("localidad");
    this.datosReserva.cp = window.localStorage.getItem("cp");
    this.datosReserva.pais = window.localStorage.getItem("pais");
    this.datosReserva.nombreFac = window.localStorage.getItem("nombreFac");
    this.datosReserva.cif = window.localStorage.getItem("cif");

    this.cargado = true;
    escribirLog(this.datosReserva);

    escribirLog("scroll");
    window.scrollTo(0,0);
  }, // fin evento mounted

};
</script>
